import React, { useEffect, useState } from "react";

import Page from "../Page/Page";
import Ashnai from "../../Containers/Profile/Ashnai";
import Gender from "../../Containers/Profile/Gender";
import Province from "../../Containers/Profile/Province";
import Education from "../../Containers/Profile/Education";
import City from "../../Containers/Profile/City";
import PictureProfile from "./PictureProfile";
import ChangeProfile from "../../Containers/Profile/ChangeProfile";

import "../../Styles/EditProfile.css";

import {
  Transaction_Login,
  Transaction_Profile,
} from "../../Connections/Transaction";

import Toast from "../../Utils/Toast";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { useLocation, useNavigate } from "react-router";
import SchoolType from "./SchoolType";
import School from "./School";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";

const EditProfile = () => {
  const navigator = useNavigate();
  const location = useLocation();

  // ==============================================================

  const [profileImage, setProfileImage] = useState();
  console.log(profileImage);
  const [oflineProfileUrl, setOflineProfileUrl] = useState();

  const [ashnaiValue, setAshnaiValue] = useState();
  const [NiknameValue, setNiknameValue] = useState();
  const [dateBirthValue, setDateBirthValue] = useState();
  const [genderValue, setGenderValue] = useState();
  const [stateValue, setStateValue] = useState();
  const [cityValue, setCityValue] = useState();
  const [shahrValue, setShahrValue] = useState();
  const [educationValue, setEducationValue] = useState();
  const [schoolValue, setSchoolValue] = useState();
  const [emailValue, setEmailValue] = useState();
  const [addressValue, setAddressValue] = useState();
  const [codePostiValue, setCodePostiValue] = useState();
  const [schoolTypeValue, setSchoolTypeValue] = useState();
  const [MobileValue, setMobileValue] = useState();
  const [provinceID, setprovinceID] = useState();
  const [CityID, setCityID] = useState();
  const [nationalCode, setNationalCode] = useState();
  const [schoolType, setSchoolType] = useState();
  const [school, setSchool] = useState();
  const [allowRules, setAllowRules] = useState(false);

  const [birthDay, setBirthDay] = useState([0, 0, 0]);

  // ======================================================

  const [provinceList, setProvinceList] = useState({ options: [] });
  const [cityList, setCityList] = useState({ options: [] });

  // ======================================================

  const [ashnaiModal, setAshnaiModal] = useState(false);
  const [genderModal, setGenderModal] = useState(false);
  const [provinceModal, setProvinceModal] = useState(false);
  const [cityModal, setCityModal] = useState(false);
  const [educationModal, setEducationModal] = useState(false);
  const [schoolTypeModal, setSchoolTypeModal] = useState(false);
  const [schoolModal, setSchoolModal] = useState(false);
  const [changeProfileModal, setChangeProfileModal] = useState(false);

  // ======================================================

  const [selectedOption, setSelectedOption] = useState();
  const [ashnai, setAshnai] = useState({});

  const [selectedGenderOption, setSelectedGenderOption] = useState();
  const [gender, setGender] = useState({});

  const [selectedEducationrOption, setSelectedEducationOption] = useState();
  const [education, setEducation] = useState({});

  const [selectedSchoolTypeOption, setSelectedSchoolTypeOption] = useState();

  const [selectedSchoolListOption, setSelectedSchoolListOption] = useState();

  const [selectedSchoolOption, setSelectedSchoolOption] = useState();

  // ======================================================

  const [UserInfo, setUserInfo] = useState({});
  const [DateYear, setDateYear] = useState([]);
  const [DateMonth, setDateMonth] = useState([]);
  const [DateDay, setDateDay] = useState([]);

  // ======================================================
  const [submitLoading, setSubmitLoading] = useState(false);
  // ======================================================

  const handleLogout = () => {
    Transaction_Login.Logout().then((res) => window.location.reload());
  };
  console.log(selectedSchoolOption);
  const handelSubmitForm = (event) => {
    event.preventDefault();
    if (allowRules) {
      let genderid;
      if (genderValue == "دختر") genderid = 2;
      else genderid = 1;

      const form = new FormData();

      form.append("Nickname", NiknameValue);
      form.append("Avatar", profileImage);
      form.append("DateOfBirth", birthDay.join("/"));
      if (addressValue) form.append("Address", addressValue);

      form.append("NationalCode", nationalCode);
      form.append("MethodOfIntroductionId", ashnaiValue.id);
      if (selectedSchoolOption != null) {
        form.append("SchoolId", selectedSchoolOption.id);
      }

      if (codePostiValue) form.append("PostalCode", codePostiValue);
      form.append("GenderId", genderid);
      setSubmitLoading(true);
      Transaction_Profile.UpdateUserInfo(form).then((res) => {
        if (res[0]) {
          Toast("success", "تغییرات با موفقیت انجام شد!");
          setSubmitLoading(false);
          navigator("/Profile");
          if (location?.state.prevPath) {
            navigator(location?.state.prevPath || "#");
          } else {
            navigator("/Profile");
          }
        } else {
          setSubmitLoading(false);
          Toast("error", res[1]);
        }
      });
    } else {
      Toast("error", "لطفا قوانین و مقررات رو قبول کن!");
    }
  };

  const renderSchoolModal = () => {
    if (cityValue?.id) {
      if (selectedEducationrOption?.id) {
        if (selectedSchoolTypeOption?.id) {
          return (
            <School
              CityId={cityValue.id}
              GradeId={selectedEducationrOption.id}
              SchoolTypeId={selectedSchoolTypeOption.id}
              setEducationValue={setSchool}
              selectedEducationrOption={selectedSchoolOption}
              setSelectedEducationOption={setSelectedSchoolOption}
              close={() => setSchoolModal(false)}
            />
          );
        } else {
          Toast(
            "warning",
            "اول باید جنسیت و استان و شهرستان و نوع مدرسه و مقطع رو کامل کنی"
          );
        }
      } else {
        Toast(
          "warning",
          "اول باید جنسیت و استان و شهرستان و نوع مدرسه و مقطع رو کامل کنی"
        );
      }
    } else {
      Toast(
        "warning",
        "اول باید جنسیت و استان و شهرستان و نوع مدرسه و مقطع رو کامل کنی"
      );
    }
  };

  const range = (start, stop, step) => {
    if (typeof stop == "undefined") {
      stop = start;
      start = 0;
    }

    if (typeof step == "undefined") {
      step = 1;
    }

    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
      return [];
    }

    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
      result.push(i);
    }

    return result;
  };

  // ======================================================

  useEffect(() => {
    var ProvinceIDTemp, CityIDtemp;
    setGender({
      options: [
        {
          id: 1,
          option: "دختر",
        },
        {
          id: 2,
          option: "پسر",
        },
      ],
    });

    Transaction_Profile.GetMethodOfIntroductions()
      .then((res) => {
        if (res[0]) {
          setAshnai({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetGrades()
      .then((res) => {
        if (res[0]) {
          setEducation({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetProfile().then((res) => {
      if (res[0]) {
        setUserInfo(res[2].data);
      } else {
        Toast("error", "مشکل در دریافت اطلاعات");
      }
    });

    Transaction_Profile.GetUserInfo().then((res) => {
      if (res[0]) {
        setMobileValue(res[2].mobile);
        setAshnaiValue({
          id: res[2].methodOfIntroductionId,
          name: res[2].methodOfIntroduction,
        });
        setDateBirthValue(res[2].dateOfBirth);
        setEmailValue(res[2].email);
        setAddressValue(res[2].address);
        setCodePostiValue(res[2].postalCode);
        setGenderValue(res[2].gender);
        setEducationValue({
          id: res[2].gradeId,
          name: res[2].grade,
        });
        setSelectedEducationOption({
          id: res[2].gradeId,
          name: res[2].grade,
        });
        setSchoolValue(res[2].school);
        setSchoolTypeValue({
          id: res[2].schoolTypeId,
          name: res[2].schoolType,
        });
        setSelectedSchoolTypeOption({
          id: res[2].schoolTypeId,
          name: res[2].schoolType,
        });
        setSelectedSchoolListOption({
          id: res[2].schoolTypeId,
          name: res[2].schoolType,
        });
        setSelectedSchoolOption({
          id: res[2].schoolId,
          name: res[2].school,
        });
        setNiknameValue(res[2].nickname);
        setShahrValue(res[2].town);
        setNationalCode(res[2].nationalCode);
        setprovinceID(res[2].provinceId);
        ProvinceIDTemp = res[2].provinceId;
        CityIDtemp = res[2].cityId;
        setCityID(res[2].cityId);
        if (res[2].gender == "Male") {
          setGenderValue("پسر");
        } else {
          setGenderValue("دختر");
        }
        setBirthDay(res[2].dateOfBirth.split("/"));
        setProfileImage(res[2].avatar);
      }
    });

    Transaction_Profile.GetSchoolTypes()
      .then((res) => {
        if (res[0]) {
          setSchoolType({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetProvinces()
      .then((res) => {
        if (res[0]) {
          setProvinceList({ options: res[2].data });
          if (ProvinceIDTemp != null) {
            setStateValue(
              res[2].data.filter((province) => province.id == ProvinceIDTemp)[0]
            );
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (stateValue != undefined) {
      Transaction_Profile.GetCities(stateValue.id).then((res) => {
        if (res[0]) {
          setCityList({ options: res[2].data });
          if (CityID != null) {
            setCityValue(res[2].data.filter((city) => city.id == CityID)[0]);
          }
        }
      });
    }
  }, [stateValue]);

  function convert(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];

    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
      return str;
    }
    return str;
  }

  // ================================================================
  return (
    <Page>
      {changeProfileModal ? (
        <ChangeProfile
          profilePicture={profileImage}
          setProfilePicture={setProfileImage}
          close={() => setChangeProfileModal(false)}
          setOflineProfileUrl={setOflineProfileUrl}
        />
      ) : null}
      {ashnaiModal ? (
        <Ashnai
          setAshnaiValue={setAshnaiValue}
          AshnaiList={ashnai}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          close={() => setAshnaiModal(false)}
        />
      ) : null}
      {genderModal ? (
        <Gender
          setGenderValue={setGenderValue}
          GenderList={gender}
          selectedGenderOption={selectedGenderOption}
          setSelectedGenderOption={setSelectedGenderOption}
          close={() => setGenderModal(false)}
        />
      ) : null}
      {educationModal ? (
        <Education
          setEducationValue={setEducationValue}
          EducationList={education}
          selectedEducationrOption={selectedEducationrOption}
          setSelectedEducationOption={setSelectedEducationOption}
          close={() => setEducationModal(false)}
        />
      ) : null}
      {provinceModal ? (
        <Province
          setProvinceValue={setStateValue}
          provinceList={provinceList}
          selectedProvinceOption={stateValue}
          close={() => setProvinceModal(false)}
        />
      ) : null}
      {cityModal ? (
        <City
          setCityValue={setCityValue}
          cityList={cityList}
          setSelectedCityOption={cityValue}
          close={() => setCityModal(false)}
        />
      ) : null}
      {schoolTypeModal ? (
        <SchoolType
          setEducationValue={setSchoolTypeValue}
          EducationList={schoolType}
          selectedEducationrOption={selectedSchoolTypeOption}
          setSelectedEducationOption={setSelectedSchoolTypeOption}
          close={() => setSchoolTypeModal(false)}
        />
      ) : null}
      {schoolModal ? renderSchoolModal() : null}
      <MobileNavBar
        text={"ویرایش اطلاعات"}
        action={() => navigator("/profile")}
      />
      <div className="Edit">
        <div className="Edit-top">
          <div className="Edit-top-right">
            <div className="Edit-top-right-inside">
              <div className="Edit-top-right-inside-text">
                <div className="Edit-top-right-inside-text-display">
                  <p className="Edit-top-right-inside-text-name">
                    {NiknameValue == undefined ? "کاربر" : NiknameValue}
                  </p>
                  <p className="Edit-top-right-inside-text-phone number-font">
                    {UserInfo.mobile}
                  </p>
                </div>
              </div>

              <div className="Edit-top-right-inside-button">
                <button
                  onClick={() => navigator("/profile")}
                  className="Edit-top-right-inside-button-edit"
                >
                  پروفایل
                </button>
                <button
                  onClick={handleLogout}
                  className="Edit-top-right-inside-button-getout"
                >
                  خروج از حساب
                </button>
              </div>
            </div>
          </div>
          <div className="Edit-top-left">
            <PictureProfile
              profileSrc={profileImage}
              setChangeProfileModal={setChangeProfileModal}
              oflineProfileUrl={oflineProfileUrl}
            />
          </div>
        </div>
        <div className="Edit-bottom">
          <div className="Edit-bottom-inside">
            <p className="Edit-bottom-inside-titleForm">
              لطفا اطلاعات زیر رو وارد کن
            </p>
            <form
              className="Edit-bottom-inside-form"
              onSubmit={handelSubmitForm}
            >
              <div className="Edit-bottom-inside-form-item">
                <div className="Edit-bottom-inside-form-div">
                  <input
                    autocomplete="off"
                    className="Edit-bottom-inside-form-div-input number-font number"
                    type="text"
                    name="number"
                    id="number"
                    onChange={(e) => setNationalCode(e.target.value)}
                    // disabled={!!!nationalCode?.id}
                    value={nationalCode}
                  />
                  <label
                    htmlFor="number"
                    className="Edit-bottom-inside-form-div-label-star"
                  >
                    کد ملی
                  </label>
                </div>
                <div className="Edit-bottom-inside-form-div div-left">
                  <input
                    autocomplete="off"
                    className="Edit-bottom-inside-form-div-input"
                    type="text"
                    name="name"
                    id="name"
                    value={NiknameValue}
                    onChange={(e) => {
                      setNiknameValue(e.target.value);
                    }}
                  />
                  <label
                    htmlFor="name"
                    className="Edit-bottom-inside-form-div-label-star"
                  >
                    نام کاربری
                  </label>
                </div>
              </div>

              <div className="Edit-bottom-inside-form-item">
                <div className="Edit-bottom-inside-form-div">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={() => setAshnaiModal(true)}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        نحوه آشنایی
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {ashnaiValue?.name}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                  {/* <input
                                        autocomplete="off"
                                        className="Edit-bottom-inside-form-div-input"
                                        type="text"
                                        name="Ashnai"
                                        id="Ashnai"
                                        value={ashnaiValue?.name}
                                        onClick={() => setAshnaiModal(true)}
                                        onChange={(e) =>
                                            setAshnaiValue(e.target.value)
                                        }
                                    />
                                    <label
                                        htmlFor="Ashnai"
                                        className="Edit-bottom-inside-form-div-label-star"
                                    >
                                        نحوه آشنایی
                                    </label>
                                    <img
                                        className="Edit-bottom-inside-form-div-icon"
                                        src="imgs/Profile/icon-edit.svg"
                                    /> */}
                </div>
                <div className="Edit-bottom-inside-form-div div-left Edit-birthDayWrapper">
                  <diiv className="Edit_profile_divData">
                    <select
                      id="ddlday"
                      className="DateBirthDropDown"
                      value={birthDay[2]}
                      onChange={(e) =>
                        setBirthDay([birthDay[0], birthDay[1], e.target.value])
                      }
                    >
                      <option value={0}>انتخاب کنید</option>
                      {range(0, 32).map((day) => (
                        <option value={day}>{day}</option>
                      ))}
                    </select>
                    <select
                      id="ddlmonth"
                      className="DateBirthDropDown"
                      value={birthDay[1]}
                      onChange={(e) =>
                        setBirthDay([birthDay[0], e.target.value, birthDay[2]])
                      }
                    >
                      <option value={0}>انتخاب کنید</option>
                      <option value={1}>فروردین</option>
                      <option value={2}>اردیبهشت</option>
                      <option value={3}>خرداد</option>
                      <option value={4}>تیر</option>
                      <option value={5}>مرداد</option>
                      <option value={6}>شهریور</option>
                      <option value={7}>مهر</option>
                      <option value={8}>آبان</option>
                      <option value={9}>آذر</option>
                      <option value={10}>دی</option>
                      <option value={11}>بهمن</option>
                      <option value={12}>اسفند</option>
                    </select>
                    <select
                      id="ddlYears"
                      className="DateBirthDropDown"
                      value={birthDay[0]}
                      onChange={(e) =>
                        setBirthDay([e.target.value, birthDay[1], birthDay[2]])
                      }
                    >
                      <option value={0}>انتخاب کنید</option>
                      {range(1330, 1401).map((year) => (
                        <option value={year}>{year}</option>
                      ))}
                    </select>
                  </diiv>
                  <label
                    htmlFor="DateBirth"
                    className="Edit-bottom-inside-form-div-label-star label-datepicker"
                  >
                    تاریخ تولد
                  </label>
                </div>
              </div>

              <div className="Edit-bottom-inside-form-item">
                <div className="Edit-bottom-inside-form-div">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={() => setGenderModal(true)}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        جنسیت
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {genderValue}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                </div>
                {/* <div className="Edit-bottom-inside-form-div div-left">
                                    <input
                                        autocomplete="off"
                                        className="Edit-bottom-inside-form-div-input"
                                        type="text"
                                        name="State"
                                        id="State"
                                        value={
                                            stateValue ? stateValue.title : ""
                                        }
                                        onClick={() => setProvinceModal(true)}
                                    />
                                    <label
                                        htmlFor="State"
                                        className="Edit-bottom-inside-form-div-label-star"
                                    >
                                        استان
                                    </label>
                                </div> */}
                <div className="Edit-bottom-inside-form-div div-left">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={() => setProvinceModal(true)}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        استان محل تحصیل
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {stateValue ? stateValue.title : ""}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                </div>
              </div>

              <div className="Edit-bottom-inside-form-item">
                {/* <div className="Edit-bottom-inside-form-div">
                                    <input
                                        autocomplete="off"
                                        className="Edit-bottom-inside-form-div-input"
                                        type="text"
                                        name="City"
                                        id="City"

                                        value={cityValue ? cityValue.title : ""}
                                        onClick={() => setCityModal(true)}
                                    />
                                    <label
                                        htmlFor="City"
                                        className="Edit-bottom-inside-form-div-label-star"
                                    >
                                        شهرستان
                                    </label>
                                    <img
                                        className="Edit-bottom-inside-form-div-icon"
                                        src="imgs/Profile/icon-edit.svg"
                                    />
                                </div> */}
                <div className="Edit-bottom-inside-form-div">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={() => setCityModal(true)}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        شهرستان محل تحصیل
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {cityValue ? cityValue.title : ""}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                </div>

                {/* <div className="Edit-bottom-inside-form-div div-left">
                                    <input
                                        autocomplete="off"
                                        className="Edit-bottom-inside-form-div-input"
                                        name="shahr"
                                        id="shahr"

                                        value={schoolTypeValue?.name}
                                        onChange={(e) =>
                                            setSchoolTypeValue(e.target.value)
                                        }
                                        onClick={() => setSchoolTypeModal(true)}
                                    />
                                    <label
                                        htmlFor="shahr"
                                        className="Edit-bottom-inside-form-div-label-star"
                                    >
                                        نوع مدرسه
                                    </label>
                                    <img
                                        className="Edit-bottom-inside-form-div-icon"
                                        src="imgs/Profile/icon-edit.svg"
                                    />
                                </div> */}
                <div className="Edit-bottom-inside-form-div  div-left">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={() => setSchoolTypeModal(true)}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        نوع مدرسه
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {schoolTypeValue?.name}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                </div>
              </div>

              <div className="Edit-bottom-inside-form-item">
                {/* <div className="Edit-bottom-inside-form-div">
                                    <input
                                        autocomplete="off"
                                        className="Edit-bottom-inside-form-div-input"
                                        type="text"
                                        name="education"
                                        id="education"

                                        value={educationValue?.name}
                                        onClick={() => setEducationModal(true)}
                                        onChange={(e) =>
                                            setEducationValue(e.target.value)
                                        }
                                    />
                                    <label
                                        htmlFor="education"
                                        className="Edit-bottom-inside-form-div-label-star"
                                    >
                                        مقطع تحصیلی
                                    </label>
                                    <img
                                        className="Edit-bottom-inside-form-div-icon"
                                        src="imgs/Profile/icon-edit.svg"
                                    />
                                </div> */}
                <div className="Edit-bottom-inside-form-div">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={() => setEducationModal(true)}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        مقطع تحصیلی
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {educationValue?.name}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                </div>
                {/* <div className="Edit-bottom-inside-form-div div-left">
                                    <input
                                        autocomplete="off"
                                        className="Edit-bottom-inside-form-div-input"
                                        type="text"
                                        name="School"
                                        id="School"
                                        value={selectedSchoolOption?.name}
                                        onChange={(e) =>
                                            setSchoolValue(e.target.value)
                                        }
                                        // disabled={!!!cityValue?.id || !!!selectedEducationrOption?.id}
                                        onClick={(e) => {
                                            if (renderSchoolModal()) {
                                                setSchoolModal(true);
                                            } else {
                                                console.log(e.target);
                                                e.target.blur();
                                            }
                                        }}
                                    />
                                    <label
                                        htmlFor="School"
                                        className="Edit-bottom-inside-form-div-label-star"
                                    >
                                        نام مدرسه
                                    </label>
                                    <img
                                        className="Edit-bottom-inside-form-div-icon"
                                        src="imgs/Profile/icon-edit.svg"
                                    />
                                </div> */}
                <div className="Edit-bottom-inside-form-div div-left">
                  <div
                    className="Edit-bottom-inside-form-div-border"
                    onClick={(e) => {
                      if (renderSchoolModal()) {
                        setSchoolModal(true);
                      } else {
                        console.log(e.target);
                        e.target.blur();
                      }
                    }}
                  >
                    <div className="Edit-bottom-inside-form-div-border-inside">
                      <label
                        htmlFor="Ashnai"
                        className="Edit-bottom-inside-form-div-border-inside-label"
                      >
                        نام مدرسه
                      </label>
                    </div>
                    <p className="Edit-bottom-inside-form-div-border-inside-text">
                      {selectedSchoolOption?.name}
                    </p>
                    <img
                      className="Edit-bottom-inside-form-div-icon"
                      src="imgs/Profile/icon-edit.svg"
                    />
                  </div>
                </div>
              </div>

              {/* <div className="Edit-bottom-inside-form-item">
                <div className="Edit-bottom-inside-form-div">
                  <input
                    autocomplete="off"
                    className="Edit-bottom-inside-form-div-input"
                    type="text"
                    name="Address"
                    id="Address"
                    value={addressValue}
                    onChange={(e) => setAddressValue(e.target.value)}
                  />
                  <label
                    htmlFor="Address"
                    className="Edit-bottom-inside-form-div-label"
                  >
                    آدرس
                  </label>
                </div>
                <div className="Edit-bottom-inside-form-div div-left">
                  <input
                    autocomplete="off"
                    className="Edit-bottom-inside-form-div-input"
                    type="number"
                    name="codePosti"
                    id="codePosti"
                    value={codePostiValue}
                    onChange={(e) => setCodePostiValue(e.target.value)}
                  />
                  <label
                    htmlFor="codePosti"
                    className="Edit-bottom-inside-form-div-label"
                  >
                    کد پستی
                  </label>
                </div>
              </div> */}

              <div className="Edit-bottom-inside-form-item">
                <div
                  className="Edit-bottom-inside-form-div"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <input
                    type="checkbox"
                    id="rules"
                    style={{ accentColor: "#2b7a0b" }}
                    checked={allowRules}
                    onChange={(e) => setAllowRules(e.target.checked)}
                  />
                  <label htmlFor="rules" className="rules-wrapper">
                    <span
                      onClick={() =>
                        navigator("/hisstori/blog/term-and-conditions")
                      }
                      className="rules-text"
                    >
                      {" "}
                      قوانین و مقررات{" "}
                    </span>{" "}
                    رو خوندم و قبول دارم.
                  </label>
                </div>
                <div className="Edit-bottom-inside-form-div div-left">
                  {submitLoading ? (
                    <span className="Edit-bottom-inside-form-submit-input w-100">
                      <LoadingSpinner />
                    </span>
                  ) : (
                    <input
                      autocomplete="off"
                      className="Edit-bottom-inside-form-submit-input w-100"
                      type="submit"
                      value="ذخیره اطلاعات"
                    />
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default EditProfile;
